export default __webpack_public_path__ + "static/media/online-services-outline-16px.651e8966.svg";